var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStripeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.016,
    height: 23.124,
    viewBox: "0 0 102.016 23.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6234",
    "data-name": "Group 6234",
    transform: "translate(0 -417.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16982",
    "data-name": "Path 16982",
    d: "M99.3,417.6H2.537A2.537,2.537,0,0,0,0,420.137H0v18.05a2.537,2.537,0,0,0,2.537,2.537H99.3a2.72,2.72,0,0,0,2.72-2.72V420.32A2.72,2.72,0,0,0,99.3,417.6Zm2.04,20.4a2.04,2.04,0,0,1-2.04,2.04H2.537A1.863,1.863,0,0,1,.68,438.187v-18.05a1.863,1.863,0,0,1,1.857-1.857H99.3a2.04,2.04,0,0,1,2.04,2.04Z",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16983",
    "data-name": "Path 16983",
    d: "M94.868,498.528H91.944v7.318H93.25v-2.829h1.619c1.632,0,2.652-.789,2.652-2.244S96.5,498.528,94.868,498.528Zm-.068,3.4H93.25v-2.244h1.571c.939,0,1.435.4,1.435,1.122s-.517,1.088-1.435,1.088Z",
    transform: "translate(-83.259 -73.284)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16984",
    "data-name": "Path 16984",
    d: "M155.845,518.4a2.564,2.564,0,0,0-2.593,2.534c0,.083,0,.165.009.247a2.591,2.591,0,1,0,5.162,0,2.557,2.557,0,0,0-2.323-2.772Q155.973,518.4,155.845,518.4Zm0,4.536c-.83,0-1.36-.68-1.36-1.755s.517-1.755,1.36-1.755,1.36.68,1.36,1.755-.537,1.748-1.36,1.748Z",
    transform: "translate(-138.774 -91.277)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16985",
    "data-name": "Path 16985",
    d: "M215.526,522.886l-.959-3.55H213.56l-.952,3.55-.966-3.55h-1.258L212,524.7h1.061l.979-3.509.979,3.509h1.061l1.612-5.359h-1.211Z",
    transform: "translate(-190.511 -92.126)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16986",
    "data-name": "Path 16986",
    d: "M292.271,518.4a2.6,2.6,0,0,0-2.556,2.653c0,.043,0,.086.006.129a2.578,2.578,0,0,0,2.365,2.774c.08.006.16.009.24.008a2.36,2.36,0,0,0,2.319-1.483l-1.013-.422a1.211,1.211,0,0,1-1.245.857,1.442,1.442,0,0,1-1.476-1.407q0-.034,0-.069h3.754v-.408A2.354,2.354,0,0,0,292.271,518.4Zm-1.313,2.129a1.306,1.306,0,0,1,1.313-1.109,1.061,1.061,0,0,1,1.149,1.1Z",
    transform: "translate(-262.347 -91.279)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16987",
    "data-name": "Path 16987",
    d: "M353.232,519.72v-.8h-1.224v5.352h1.224v-2.809a1.285,1.285,0,0,1,1.36-1.36,3.184,3.184,0,0,1,.449,0v-1.224h-.347A1.557,1.557,0,0,0,353.232,519.72Z",
    transform: "translate(-318.758 -91.715)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16988",
    "data-name": "Path 16988",
    d: "M389.327,518.4a2.6,2.6,0,0,0-2.556,2.653c0,.043,0,.086.006.129a2.578,2.578,0,0,0,2.365,2.774c.08.006.16.009.24.008a2.36,2.36,0,0,0,2.292-1.483l-1.047-.4a1.211,1.211,0,0,1-1.245.857,1.442,1.442,0,0,1-1.429-1.455c0-.007,0-.014,0-.021h3.768v-.408A2.383,2.383,0,0,0,389.327,518.4Zm-1.313,2.129a1.306,1.306,0,0,1,1.306-1.1,1.061,1.061,0,0,1,1.149,1.1Z",
    transform: "translate(-350.235 -91.279)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16989",
    "data-name": "Path 16989",
    d: "M449.073,501.085a1.938,1.938,0,0,0-1.537-.68c-1.5,0-2.36,1.258-2.36,2.782s.857,2.782,2.36,2.782a1.918,1.918,0,0,0,1.537-.68v.558H450.3v-7.318h-1.224Zm0,2.278a1.36,1.36,0,0,1-1.36,1.551c-.891,0-1.36-.68-1.36-1.714s.476-1.714,1.36-1.714a1.382,1.382,0,0,1,1.36,1.557Z",
    transform: "translate(-403.125 -73.284)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16990",
    "data-name": "Path 16990",
    d: "M544.235,500.405a1.959,1.959,0,0,0-1.571.68v-2.557H541.44v7.318h1.224v-.565a1.945,1.945,0,0,0,1.544.68c1.5,0,2.353-1.265,2.353-2.782S545.731,500.405,544.235,500.405Zm-.211,4.489a1.36,1.36,0,0,1-1.36-1.551v-.32c0-1.007.571-1.557,1.36-1.557.884,0,1.36.68,1.36,1.714S544.875,504.894,544.024,504.894Z",
    transform: "translate(-490.296 -73.284)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16991",
    "data-name": "Path 16991",
    d: "M600.925,523.1l-1.313-3.761H598.32l1.972,5.162-.2.5a.68.68,0,0,1-.775.537,2.811,2.811,0,0,1-.408,0v1.027a3.143,3.143,0,0,0,.5.034,1.816,1.816,0,0,0,1.891-1.36l2.2-5.862H602.21Z",
    transform: "translate(-541.803 -92.126)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16992",
    "data-name": "Path 16992",
    d: "M869.617,507.1a2.04,2.04,0,0,0-1.449.592l-.1-.469h-1.625v8.787l1.85-.4v-2.129a2.04,2.04,0,0,0,1.313.476c1.319,0,2.53-1.081,2.53-3.475C872.141,508.286,870.916,507.1,869.617,507.1Zm-.442,5.189a1.1,1.1,0,0,1-.871-.354v-2.8a1.115,1.115,0,0,1,.884-.374c.68,0,1.143.768,1.143,1.755s-.469,1.768-1.156,1.768Z",
    transform: "translate(-784.604 -81.042)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16993",
    "data-name": "Path 16993",
    d: "M935.407,507.1c-1.782,0-2.863,1.537-2.863,3.475,0,2.292,1.279,3.455,3.1,3.455a4.162,4.162,0,0,0,2.04-.5V512a3.939,3.939,0,0,1-1.836.422c-.734,0-1.36-.265-1.455-1.156h3.659v-.68C938.114,508.633,937.189,507.1,935.407,507.1Zm-1,2.768c0-.857.524-1.217.986-1.217s.952.36.952,1.217Z",
    transform: "translate(-844.457 -81.042)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16994",
    "data-name": "Path 16994",
    d: "M797.365,507.635l-.116-.558h-1.578v6.6h1.823v-4.475a1.272,1.272,0,0,1,1.394-.394v-1.734A1.224,1.224,0,0,0,797.365,507.635Z",
    transform: "translate(-720.514 -80.949)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16995",
    "data-name": "Path 16995",
    d: "M698.182,509.154c0-.3.245-.415.632-.415a4.012,4.012,0,0,1,1.836.49V507.44a4.762,4.762,0,0,0-1.836-.347c-1.5,0-2.5.8-2.5,2.149,0,2.108,2.816,1.768,2.816,2.673,0,.354-.3.469-.68.469a4.612,4.612,0,0,1-2.04-.612V513.6a5.02,5.02,0,0,0,2.04.435c1.537,0,2.6-.782,2.6-2.149C701.011,509.6,698.182,510.011,698.182,509.154Z",
    transform: "translate(-630.539 -81.04)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16996",
    "data-name": "Path 16996",
    d: "M755.126,491.328l-1.8.394V497.8a1.884,1.884,0,0,0,1.814,1.951c.035,0,.069,0,.1,0a2.83,2.83,0,0,0,1.3-.252v-1.53c-.238.1-1.4.449-1.4-.68v-2.72h1.4v-1.591h-1.4Z",
    transform: "translate(-682.164 -66.764)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16997",
    "data-name": "Path 16997",
    d: "M837,484.041l1.857-.388v-1.469l-1.857.388Z",
    transform: "translate(-757.938 -58.483)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5259",
    "data-name": "Rectangle 5259",
    width: 1.857,
    height: 6.556,
    transform: "translate(79.062 426.176)",
    fill: "#635bff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeIcon);
export default __webpack_public_path__ + "static/media/Stripe-icon.55f6bc8af3e8deb38b7793da0afde113.svg";
export { ForwardRef as ReactComponent };